import React from 'react';
import styles from './TaskListSkeleton.module.css';

export function TaskListSkeleton() {
    return (
        <div className={styles.SkeletonContainer}>
            <div className={styles.SkeletonListItem}>
                <div className={styles.header}>
                    <div className={styles.tab}></div>
                </div>
                <div className={styles.main}></div>
            </div>
            <div className={styles.SkeletonListItem}>
                <div className={styles.header}>
                    <div className={styles.tab}></div>
                </div>
                <div className={styles.main}></div>
            </div>
            <div className={styles.SkeletonListItem}>
                <div className={styles.header}>
                    <div className={styles.tab}></div>
                </div>
                <div className={styles.main}></div>
            </div>
            <div className={styles.SkeletonListItem}>
                <div className={styles.header}>
                    <div className={styles.tab}></div>
                </div>
                <div className={styles.main}></div>
            </div>
            <div className={styles.SkeletonListItem}>
                <div className={styles.header}>
                    <div className={styles.tab}></div>
                </div>
                <div className={styles.main}></div>
            </div>
            <div className={styles.SkeletonListItem}>
                <div className={styles.header}>
                    <div className={styles.tab}></div>
                </div>
                <div className={styles.main}></div>
            </div>
            <div className={styles.SkeletonListItem}>
                <div className={styles.header}>
                    <div className={styles.tab}></div>
                </div>
                <div className={styles.main}></div>
            </div>
        </div>
    );
}
